export default __webpack_public_path__ + "static/media/star.png.webp";